import React from 'react';
import PopUpDialogTemplate from './PopUpDialogTemplate';
import { formatCurrency } from '../../../../helpers/format';
import { useTranslation } from 'react-i18next';
import { getTournamentBuyinInfo } from '../../../Club/Main/components/Tabs/components/TournamentCasino/helpers/getTournamentBuyinInfo';

const TournamentStartInformationDialog = ({ data, onConfirm}) => {
  const { t } = useTranslation();
  const { chipValue } = getTournamentBuyinInfo(data);

  const BTN_NAMES = {
    confirm: t('ok'),
  };
  if (!data) return false;

  return (
    <>
      <div className="tournaments__popup tournaments__dialog-bet-information">
        <div className="tournaments__popup__overlay tournaments__dialog-bet-information__overlay" onClick={onConfirm} />
        <PopUpDialogTemplate
          onConfirm={onConfirm}
          onClose={onConfirm}
          btnNames={BTN_NAMES}
          btnClasses={ {confirm: 'primary'} }
          // errorHeader
          className="popup__dialog--wide popup__dialog--notification"
          bodyClassName="tournaments__dialog-bet-information__body"
        >
          <div className="tournaments__dialog-bet-information__image-wrapper">
            <img src={data.tournamentGames[0].thumbnail} className="tournaments__dialog-bet-information__image" />
          </div>
          <div className="tournaments__dialog-bet-information__game-info-wrapper">
            <div className="tournaments__dialog-bet-information__title">
              <span>{data.tournamentName}</span>
            </div>
            <div className="tournaments__dialog-bet-information__bet-info-wrapper">
              <div className="tournaments__dialog-bet-information__bet-info">
                <div className="tournaments__dialog-bet-information__bet-info-item">
                  <span>{t('tournaments.betAmount')}:</span>
                  <b>{data.minBet}</b>
                </div>
                <div className="tournaments__dialog-bet-information__bet-info-item">
                  {/* will translate 'Spins' */}
                  <span>{t('spins')}:</span>
                  <b>{data.numberOfSpins}</b>
                </div>
              </div>
              <div className="tournaments__dialog-bet-information__bet-info">
                <div className="tournaments__dialog-bet-information__bet-info-item">
                  <span>{t('tournaments.prizePool')}:</span>
                  <b>{chipValue({val: data.prizePool.value, margin: 4})}</b>
                </div>
                <div className="tournaments__dialog-bet-information__bet-info-item">
                <span>{t('tournaments.players')} :</span>
                  <b>{data.enrolled}</b>
                </div>
                <div className="tournaments__dialog-bet-information__bet-info-item">
                  <span>{t('tournaments.allowedReBuys')}:</span>
                  <b>{t('tournaments.no')}</b>
                </div>
              </div>
            </div>
          </div>
        </PopUpDialogTemplate>
      </div>
    </>
  )
}

export default TournamentStartInformationDialog;